export enum RouteUrl {
	ADMIN = 'admin',
	AUTHENTICATION = 'auth',
	LOGIN = 'login',
	ADD_MURAL = 'add-mural',
	MURALS = 'murals',
	ORDERS = 'orders',
	ORDER_DETAILS = 'order-details',
	PICTURES = 'pictures',
	ADD_PICTURE = 'add-picture',
	PITCHERS = 'pitchers',
	ADD_PITCHER = 'add-pitcher',
	PRODUCTS = 'products',
	ADD_PRODUCT = 'add-product'
}
